
<template>
  <div class="countDown">
      <slot></slot>
  </div>
</template>

<script >
import { timestamp2Time } from '../../utils/timeCalculate'

export default {
    name: 'countDown',
    props: {
        timestamp: {
            type: Number,
            default: 0
        },
        hasDay: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            t1: null,
            remainTime: 0
        }
    },
    created () {

    },
    activated () {

    },
    /* 销毁定时器 */
    beforeDestroy () {
        clearTimeout(this.t1)
    },
    mounted () {
        this.remainTime = this.timestamp
    },
    watch: {
        timestamp (nVal) {
            this.remainTime = nVal
        }
    },
    methods: {
        start () {
            if (this.t1) {
                clearTimeout(this.t1)
            }
            /* 开始倒计时 */
            this.countDown()
        },
        end () {
            if (this.t1) {
                clearTimeout(this.t1)
            }
        },
        /**
         * 倒计时
         */
        countDown () {
            this.t1 = setTimeout(() => {
                if (this.remainTime > 0) {
                    this.remainTime -= 1
                }
                const timeInfo = timestamp2Time(this.remainTime, this.hasDay)
                const isEnd = this.remainTime <= 0
                this.$emit('callBack', Object.assign(timeInfo, {
                    isEnd: isEnd,
                    remainTime: this.remainTime
                }))
                if (isEnd) {
                    return
                }
                this.countDown()
            }, 1000)
        }
    },

}
</script>
